import { useState, useEffect } from 'react';
import { NAV_LINKS } from '../constants/navigation';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [hidden, setHidden] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    let lastY = window.scrollY;

    const handleScroll = () => {
      const currentY = window.scrollY;
      setScrolled(currentY > 24);
      setHidden(currentY > lastY && currentY > 120 && !open);
      lastY = currentY;
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [open]);

  useEffect(() => {
    if (open) setHidden(false);
  }, [open]);

  const goto = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    setOpen(false);
  };

  return (
    <nav className={`nav ${scrolled ? 'is-scrolled' : ''} ${hidden ? 'is-hidden' : ''}`}>
      <div className="nav-inner">
        <div className="nav-logo">
          <span className="brand-logo-frame brand-logo-symbol-frame" aria-hidden="true">
            <img className="brand-logo" src="/logo.jpg" alt="" />
          </span>
          <span className="brand-wordmark" aria-label="Kalakar Tech Crew">
            <span className="brand-wordmark-main">Kalakar</span>
            <span className="brand-wordmark-sub">TECH CREW</span>
          </span>
        </div>

        <div className="nav-links">
          {NAV_LINKS.map((link) => (
            <button
              key={link.id}
              onClick={() => goto(link.id)}
              className="nav-link"
            >
              {link.label}
            </button>
          ))}
          <button
            onClick={() => goto('contact')}
            className="btn btn-primary btn-small"
          >
            Get Started
          </button>
        </div>

        <button
          className="nav-toggle"
          aria-label="Toggle navigation"
          aria-expanded={open}
          onClick={() => setOpen(!open)}
        >
          {[0, 1, 2].map((i) => (
            <span key={i} />
          ))}
        </button>
      </div>

      <div className={`nav-mobile ${open ? 'open' : ''}`}>
        {NAV_LINKS.map((link) => (
          <button
            key={link.id}
            onClick={() => goto(link.id)}
            className="nav-link"
          >
            {link.label}
          </button>
        ))}
      </div>
    </nav>
  );
}
